import { useState } from 'react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-white shadow-sm">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <div className="text-indigo-600 font-bold text-xl">Lyne</div>

            <nav className="hidden md:flex ml-10 space-x-8">
              <a href="#" className="text-gray-700 hover:text-indigo-600 transition-colors">
                Dashboard
              </a>
            </nav>
          </div>

          <div className="hidden md:flex items-center space-x-4"></div>

          <div className="md:hidden">
            <button
              className="text-gray-700 hover:text-indigo-600"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              {isMenuOpen ? (
                <img src="/close.svg" alt="Close menu" className="h-6 w-6" />
              ) : (
                <img src="/menu.svg" alt="Open menu" className="h-6 w-6" />
              )}
            </button>
          </div>
        </div>

        {isMenuOpen && (
          <div className="md:hidden mt-4 pt-4 border-t border-gray-200">
            <nav className="flex flex-col space-y-4">
              <a href="#" className="text-gray-700 hover:text-indigo-600 transition-colors">
                Dashboard
              </a>
            </nav>

            <div className="mt-4 pt-4 border-t border-gray-200 flex flex-col space-y-4"></div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
